import { render, staticRenderFns } from "./dictionary-list.vue?vue&type=template&id=73603f4c&"
import script from "./dictionary-list.vue?vue&type=script&lang=js&"
export * from "./dictionary-list.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports